import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box';
import WorkCard from "./WorkCards";
import kratin from "../../Assets/Work/Kratin Logo.png";
import MonaliS from "../../Assets/Work/MonaliS.png";
import KratinSocial from "../../Assets/Work/kratinsocial.png";
import KratinPortal from "../../Assets/Work/kratinportal.png";
import MonaliSOut from "../../Assets/Work/monalis-out.png";
import Insights from "../../Assets/Work/Insights.png";
import WorkTimeline from "../../Assets/Work/work.png";
import WorkTimelineMobile from "../../Assets/Work/work-mobile.png";
import './Work.css'
import { Link } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "../Footer";

function Experience() {
  return (
    <section>
      <Navbar />
      <Box className="filebox">
        <Row>
          <aside>
          <Col sm={1}>
            <Container style={{ height: '100%' }}>
            
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '40s' }}>
              EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.          EXPERIENCE.         EXPERIENCE.           
                </div>
                </div>
                </div>
            </Container>
          </Col>
          <Col className="leftpad" sm={10} style={{paddingLeft: '8%'}}>
            <Container className="work-section" id="work">
              <Container className="work-content">
                <Row style={{  paddingBottom: "2%" }}>
                  <Col style={{ justifyItems: 'center', alignItems: 'center' }}>
                    <img src={WorkTimeline} alt="work" className="img-fluid" id="work-img" />
                    <img src={WorkTimelineMobile} alt="work" className="img-fluid" id="work-img-mob" />
                  </Col>
                </Row>
                <Row style={{ justifyItems: 'start', paddingTop: '2%', paddingBottom: '2%' }} className="TCI">
                <Link to={'/experience/truliacareinsights'} style={{textDecoration: 'none'}}>
                    <WorkCard
                      imgLogo={kratin}
                      title="TruliaCare Insights"
                      role="Visual Design Intern, UI/UX, Testing"
                      description="A healthcare solution who analyses and identifies gaps in your hospice care and assists you in making informed decisions."
                      imgWay={Insights}
                    />
                </Link>
                </Row>

                <Row style={{ justifyItems: 'start', paddingTop: '2%', paddingBottom: '2%'  }} className="KP">
                <Link to={'/experience/kratinportal'} style={{textDecoration: 'none'}}>
                    <WorkCard
                      imgLogo={kratin}
                      title="Kratin Portal"
                      role="Visual Design Intern, Product Owner"
                      description="A unified platform for all employees which allows them to conveniently access all office-related tasks."
                      webLink="https://www.linkedin.com/company/kratin-software-solutions/mycompany/verification/"
                      imgWay={KratinPortal}
                    />
                </Link>
                </Row>

                <Row style={{ justifyItems: 'start', paddingTop: '2%', paddingBottom: '2%' }} className="KB">
                <Link to={'/experience/kratinbranding'} style={{textDecoration: 'none'}}>
                    <WorkCard
                      imgLogo={kratin}
                      title="Social Media & Brand Awareness"
                      role="Visual Design Intern"
                      description="Kratin Software Solutions is a healthcare-focused technology solutions providers with presence in US and India."
                      webLink="https://www.linkedin.com/company/kratin-software-solutions/mycompany/verification/"
                      imgWay={KratinSocial}
                    />
                </Link>
                </Row>

                <Row style={{ justifyItems: 'start', paddingTop: '2%', paddingBottom: '2%'  }} className="MonaliS">
                <Link to={'/experience/monalis'} style={{textDecoration: 'none'}}>
                    <WorkCard
                      imgLogo={MonaliS}
                      title="Fashion Lookbook and Social Media"
                      role="Graphic Designer, Social Media Intern"
                      description="Monali S is a pret and couture clothing line for everyone-men, women and kids with its presence online and offline."
                      webLink="https://drive.google.com/file/d/1s9ihoPGi7Zmro0LEG43arcvOuKE7iD2d/view?usp=share_link"
                      imgWay={MonaliSOut}
                    />
                </Link>
                </Row>
              </Container>
            </Container>
          </Col>
          </aside>
        </Row>
        <Footer />

      </Box>

    </section>

  );
}


export default Experience;
